import { connect } from "react-redux";
import EmAssignTicket from "./emAssignTicket";
import { bindActionCreators } from "redux";
import {fetchPmTicketAssignee} from "services/redux/maintenance/pmTicket/action";
import {postTicketAssignment} from "services/redux/maintenance/employeeTickets/action";
import {fetchPmAssignee} from "services/redux/maintenance/pmTicket/action";


const mapStateToProps = (state) => ({
  pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmTicketAssignee,
      fetchPmAssignee,
      postTicketAssignment,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmAssignTicket);
